import { useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { useAppSelector, useAppDispatch } from '@/hooks';
import { renderComponent, registerAndRedirect } from '@/utils';
import { POS_APP_REDIRECT_BASE_URL } from '@/config/env';
import { getSignUpConfig } from './config';
import { updateApplicationData } from '@/store/slices/loanApplication.slice';

/**
 * SignUp Dialog Page
 *
 * Displays a dialog with:
 * - Revolution logo
 * - First Name, Last Name, and Email fields
 * - Sign button
 *
 * This page appears after clicking Next from the LoanSetup page (Loan Type)
 * On Sign, redirects to POS app with loan application data
 *
 * Uses config-driven UI pattern for flexibility and maintainability.
 */
const SignUp = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  // Get Redux state for building query params
  const loanApplication = useAppSelector((state) => state.loanApplication);

  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');

  const handleSign = async () => {
    // Log sign data
    console.log('Sign clicked:', { firstName, lastName, email });

    // Update Redux with user details before registration
    dispatch(updateApplicationData({ firstName, lastName, email }));

    // Create updated loanApplication with user details
    const updatedLoanApplication = {
      ...loanApplication,
      application: {
        ...loanApplication.application,
        firstName,
        lastName,
        email,
      },
    };

    try {
      // Register user and redirect to POS app
      await registerAndRedirect({
        baseUrl: POS_APP_REDIRECT_BASE_URL,
        loanApplication: updatedLoanApplication,
        role: 'borrower',
      });
    } catch (error) {
      console.error('User Registration Error:', error);
    }
  };

  const isFormValid = Boolean(
    firstName.trim() && lastName.trim() && email.trim()
  );

  const config = getSignUpConfig({
    theme,
    t,
    firstName,
    lastName,
    email,
    onFirstNameChange: setFirstName,
    onLastNameChange: setLastName,
    onEmailChange: setEmail,
    onSign: handleSign,
    isFormValid,
  });

  return <>{renderComponent(config, 0, false)}</>;
};

export { SignUp };
export default SignUp;
